<div class="banner">
  <h5 class="banner-title flex justify-center pb-3" style="margin-bottom: 0;">What's in BioConnect</h5>
  <div class="flex-row-container" style="padding:0">
    <div class="flex item w-full justify-center rounded-border h-full bg-zinc-100">
        <img src="../assets/images/study-navy.png" class="icon"> <!--icon doesn't match design due to absence of comparable icon in primeNG library, left pre-existing icon in place-->
        <div class="pl-4 blue-font">
          <div class="number">{{ totalStudies }}</div>
          <div class="label">Studies</div>
        </div>
      </div>
      <div class="flex item w-full justify-center rounded-border h-full bg-zinc-100">
        <img src="../assets/images/microscope-navy.png" class="icon">
        <div class="pl-4 blue-font">
          <div class="number">{{ totalAssays }}</div>
          <div class="label">Assays</div>
        </div>
      </div>
      <div class="flex item w-full justify-center rounded-border h-full bg-zinc-100">
        <img src="../assets/images/folder-navy.png" class="icon">
        <div class="pl-4 blue-font">
          <div class="number">{{ totalFiles }}</div>
          <div class="label">Files</div>
        </div>
      </div>
      <div class="flex item w-full justify-center rounded-border h-full bg-zinc-100">
        <img src="../assets/images/protocol-navy.png" class="icon"> <!-- icon doesn't match design due to absence of comparable icon in primeNG library-->
        <div class="pl-4 blue-font">
          <div class="number">{{ totalProtocols }}</div>
          <div class="label">Protocols</div>
        </div>
    </div>
  </div>
</div>  